import { DocBehavior, DocType, WhitelabelDocsConfig } from './types';

export const DOC_PATH_PREFIX = '/docs';

export const buildDocUrl = (slug: string, locale: string): string =>
  `${DOC_PATH_PREFIX}/${slug}/${locale}.html`;

export const getDocBehavior = (
  type: DocType,
  docsConfig?: WhitelabelDocsConfig,
): DocBehavior => docsConfig?.types?.[type] ?? DocBehavior.Default;

/**
 * Synchronously resolve the doc URL for a given doc type + locale + whitelabel.
 * Returns the prefixed URL when the whitelabel overrides this doc type,
 * otherwise the default URL.
 */
export const resolveDocUrl = (
  type: DocType,
  locale: string,
  docsConfig?: WhitelabelDocsConfig,
): string =>
  getDocBehavior(type, docsConfig) === DocBehavior.Override && docsConfig
    ? buildDocUrl(`${docsConfig.prefix}${type}`, locale)
    : buildDocUrl(type, locale);

/**
 * Resolve the `hash.json` key for a given doc type + whitelabel.
 * Returns the prefixed key for overridden doc types, the plain type otherwise.
 */
export const resolveDocHashKey = (
  type: DocType,
  docsConfig?: WhitelabelDocsConfig,
): string =>
  getDocBehavior(type, docsConfig) === DocBehavior.Override && docsConfig
    ? `${docsConfig.prefix}${type}`
    : type;
